// extracted by mini-css-extract-plugin
export var bgImageLeftStyle = "rsc_hb_in_page_contact_form-module--bgImageLeftStyle--X83oP";
export var bgImageRightStyle = "rsc_hb_in_page_contact_form-module--bgImageRightStyle--23Ezs";
export var bgImageWrapperStyle = "rsc_hb_in_page_contact_form-module--bgImageWrapperStyle--db0yT";
export var formWrapperStyle = "rsc_hb_in_page_contact_form-module--formWrapperStyle--1BnUF";
export var subtitleStyle = "rsc_hb_in_page_contact_form-module--subtitleStyle--BrSb5";
export var wrapperStyle = "rsc_hb_in_page_contact_form-module--wrapperStyle--OrHN3";